import React from 'react';
import PropTypes from 'prop-types';
import styles from './SchedulePill.module.scss';
import { getScheduleColor } from '../../utils/specialityUtils';

export { getScheduleColor };

const SchedulePill = ({ text, colorId, variant = 'solid' }) => {
  if (!text) return null;
  return (
    <span
      className={`${styles.pill} ${styles[variant]} ${styles[getScheduleColor(colorId)]}`}
      title={text}
    >
      {text}
    </span>
  );
};

SchedulePill.propTypes = {
  text: PropTypes.string,
  colorId: PropTypes.number,
  variant: PropTypes.oneOf(['solid', 'outline']),
};

export default SchedulePill;
